var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhoneFill = function SvgPhoneFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F7F7",
    cx: 19.815,
    cy: 19.815,
    r: 19.815
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.26 24.87-3.95-1.749a.978.978 0 0 0-.988.125l-1.605 1.125a1.832 1.832 0 0 1-1.604.124 58.025 58.025 0 0 1-5.431-5.622 1.515 1.515 0 0 1 .123-1.624l1.111-1.5c.238-.325.285-.754.124-1.124l-1.852-3.874a1.111 1.111 0 0 0-1.11-.75h-1.729a4.256 4.256 0 0 0-2.345 4c0 4.497 3.703 8.62 5.431 10.37 1.728 1.749 5.801 5.622 10.492 5.622 0 0 2.962.25 3.95-2.249 0-.125.123-.25.123-.5v-1.25a1.625 1.625 0 0 0-.74-1.124Z",
    fill: "#636363",
    fillRule: "nonzero"
  }))));
};

export default SvgPhoneFill;